const GradientSuccessMarkIcon: React.FC = () => {
  return (
    <svg width="105" height="77" viewBox="0 0 105 77" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M35.6627 75.4877L1.53763 41.9292C-0.512542 39.913 -0.512542 36.6441 1.53763 34.6278L8.96208 27.3264C11.0122 25.31 14.3366 25.31 16.3867 27.3264L39.375 49.9328L88.6133 1.5121C90.6634 -0.504033 93.9878 -0.504033 96.0379 1.5121L103.462 8.81351C105.513 10.8296 105.513 14.0986 103.462 16.1149L43.0873 75.4879C41.0369 77.5041 37.7128 77.5041 35.6627 75.4877Z" fill="url(#paint0_linear_53_15564)" />
      <defs>
        <linearGradient id="paint0_linear_53_15564" x1="0" y1="0" x2="117.526" y2="35.3244" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00995D" />
          <stop offset="1" stopColor="#B1D34B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GradientSuccessMarkIcon;